module.exports = __webpack_public_path__ + "static/media/learn.2f2a3f38.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/learn.mp3
// module id = 742
// module chunks = 0